<h2 mat-dialog-title>{{_title}}</h2>

<mat-dialog-content>
    @if(_innerHtml){
        <p [innerHTML]="_innerHtml"></p>
    }
    @else{
        <p>{{_description}}</p>
    }
    
    @if(_showTextarea) {
        <mat-form-field appearance="outline">
            <mat-label>{{ _textareaLabel }}</mat-label>
            <textarea matInput
                      [(ngModel)]="_textareaValue"
                      [required]="_textareaRequired"
                      [minlength]="_textareaMinLength"
                      rows="4"
                      cdkTextareaAutosize>
            </textarea>
            @if(_textareaRequired && _textareaMinLength > 0) {
                <mat-hint align="end">{{ _textareaValue.length }} / {{ _textareaMinLength }}</mat-hint>
            }
        </mat-form-field>
    }
    </mat-dialog-content>

<mat-dialog-actions class="action-buttons">
    <button mat-flat-button class="btn-secondary" (click)="close()">{{_buttonClose}}</button>
    <button mat-flat-button 
            class="btn-primary" 
            (click)="confirm()"
            [disabled]="isConfirmDisabled"> {{_buttonConfirm}}
    </button>
</mat-dialog-actions>